import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {sdoNs} from '../constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';
import '../session-sdo';

/**
 * @summary HideForLevel
 * @extends {AoflElement}
 */
@customElement('hide-for-level')
class HideForLevel extends AoflElement {
  /**
   * Creates an instance of HideForLevel.
   */
  constructor() {
    super();
  }
  /**
   * @readonly
   */
  static is = 'hide-for-level';
  @property({type: Number, mapState: `${sdoNs.SESSION}.group_info.level`, store: storeInstance})
  currentLevel = 0;

  @property({type: Number, mapState: `${sdoNs.SESSION}.$topLevel`, store: storeInstance})
  topLevel = 0;

  @property({type: Number, mapState: `${sdoNs.SESSION}.$classLevel`, store: storeInstance})
  classLevel = 0;

  @property({type: Array, attribute: 'disable-levels'})
  disableLevels = [];

  @property({type: Boolean, attribute: 'disable-classes'})
  disableClasses = false;

  @property({type: Boolean, attribute: 'disable-top'})
  disableTop = false;

  @property({type: Boolean})
  hide = false;

  shouldUpdate(changedProperties) {
    if (
      (this.disableLevels.indexOf(this.currentLevel) !== -1) || // hide if specified
      (this.disableClasses && this.currentLevel === this.classLevel) || // hide if class matches
      (this.disable && this.currentLevel === this.topLevel) // hide org level
    ) {
      this.hide = true;
    } else {
      this.hide = false;
    }

    return true;
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }
}

export default HideForLevel;
